import Comp from "./SingleTeamMemberResults";

export default Comp;
